import { render } from "./AnchorButton.vue?vue&type=template&id=33b5a7a1"
import script from "./AnchorButton.vue?vue&type=script&lang=ts"
export * from "./AnchorButton.vue?vue&type=script&lang=ts"
script.render = render

export default script